// Currency formatting + brand helpers based on backend /api/settings
const DEFAULT_LOCALE_BY_CODE = {
  INR: "en-IN",
  USD: "en-US",
  EUR: "de-DE",
  GBP: "en-GB",
  AUD: "en-AU",
  CAD: "en-CA",
  SGD: "en-SG",
  AED: "ar-AE",
  ZAR: "en-ZA",
  NGN: "en-NG",
  KES: "en-KE",
};

export function formatMoney(amount, currency) {
  const code = currency?.code || "INR";
  const symbol = currency?.symbol || "₹";
  const n = Number(amount || 0);
  // Try locale-aware first
  try {
    return new Intl.NumberFormat(DEFAULT_LOCALE_BY_CODE[code] || "en-IN", {
      style: "currency",
      currency: code,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(n);
  } catch {
    return `${symbol}${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
}

export function moneyShort(amount, currency) {
  const symbol = currency?.symbol || "₹";
  const n = Number(amount || 0);
  if (Math.abs(n) >= 1_00_00_000) return `${symbol}${(n / 1_00_00_000).toFixed(1)}Cr`;
  if (Math.abs(n) >= 1_00_000) return `${symbol}${(n / 1_00_000).toFixed(1)}L`;
  if (Math.abs(n) >= 1000) return `${symbol}${(n / 1000).toFixed(1)}K`;
  return `${symbol}${n.toFixed(0)}`;
}
